import { AuthContextProps as UtilAuthContextProps } from '@soniq/util-auth'
import { createContext } from 'react'

export interface AuthProviderState {
  error: Error | null
}

export interface AuthContextProps
  extends UtilAuthContextProps,
    AuthProviderState {}

export const AuthContext = createContext<AuthContextProps>(
  {} as never
)
